export default {
  namespace: 'dms',
  namespaced: true,
  state: {},
  mutations: {},
  actions: {},
  modules: {},
};
